var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.userConfirmationManager.state.isVisible)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"message-box"},[_c('p',[_vm._v(_vm._s(_vm.userConfirmationManager.state.message))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }